import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import '../admin/styles/admin.css'

const pages = import.meta.glob('../admin/pages/**/*.tsx', { eager: false })

createInertiaApp({
  resolve(name) {
    const path = `../admin/pages/${name}.tsx`
    const importPage = pages[path]
    if (!importPage) {
      throw new Error(`Page not found: ${name}. Checked: ${path}. Available: ${Object.keys(pages).join(', ')}`)
    }
    return importPage() as any
  },
  setup({ el, App, props }) {
    createRoot(el).render(createElement(App, props))
  },
})
